/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function deskDeliveryNavInit() {
  var $controls = $('.desk_delivery-page-nav .desk_delivery-nav-control, .table-of-content-mobile .table-of-content__item');
  var $targets = $('.desk_delivery-page-content [data-nav-target]');
  if (!$controls.length || !$targets.length) return;
  var tocMobile = deskTocMobileInit($('.table-of-content-mobile'), $('.desk_delivery-page-container'));
  var navOffset = 120;
  var lockSpy = false;
  var lockTimer = null;

  function deskDeliveryNavOffset() {
    if (window.innerWidth >= 1440) return navOffset;
    return tocMobile.getOffset();
  }

  function deskDeliveryNavSetActive(id) {
    $controls.removeClass('active');
    $controls.filter('[data-nav="' + id + '"]').addClass('active');
  }

  function deskDeliveryNavUnlock() {
    lockSpy = false;
  }

  function deskDeliveryNavClick() {
    var id = $(this).data('nav');
    var $target = $targets.filter('[data-nav-target="' + id + '"]');
    if (!$target.length) return;

    lockSpy = true;
    deskDeliveryNavSetActive(id);
    clearTimeout(lockTimer);
    lockTimer = setTimeout(deskDeliveryNavUnlock, 1000);

    var offset = deskDeliveryNavOffset();
    if (window.lenis && window.lenis.scrollTo) {
      window.lenis.scrollTo($target[0], { offset: -offset, onComplete: deskDeliveryNavUnlock });
    } else {
      $('html, body').stop(true).animate({ scrollTop: $target.offset().top - offset }, 500, deskDeliveryNavUnlock);
    }
  }

  function deskDeliveryNavSpy() {
    if (lockSpy) return;
    var pos = (window.scrollY || window.pageYOffset) + deskDeliveryNavOffset() + 1;
    var activeId = null;
    $targets.each(function () {
      if ($(this).offset().top <= pos) activeId = $(this).data('nav-target');
    });
    if (activeId !== null) deskDeliveryNavSetActive(activeId);
  }

  $controls.on('click', deskDeliveryNavClick);
  if (window.lenis && window.lenis.on) {
    window.lenis.on('scroll', deskDeliveryNavSpy);
  } else {
    $(window).on('scroll', deskDeliveryNavSpy);
  }
  deskDeliveryNavSpy();
}

$(document).ready(deskDeliveryNavInit);
